import { ReactNode } from 'react';

type FormActionBarProps = {
  children: ReactNode;
  onCancel?: () => void;
  cancelLabel?: string;
  /** Quando omitido, o Cancelar aparece sempre que `onCancel` for informado. */
  showCancel?: boolean;
  className?: string;
};

export function FormActionBar({
  children,
  onCancel,
  cancelLabel = 'Cancelar',
  showCancel,
  className = 'erp-btn-actions',
}: FormActionBarProps) {
  const shouldShowCancel = (showCancel ?? Boolean(onCancel)) && Boolean(onCancel);

  return (
    <div className={className}>
      {shouldShowCancel ? (
        <button type="button" className="erp-btn-secondary" onClick={onCancel}>
          {cancelLabel}
        </button>
      ) : null}
      {children}
    </div>
  );
}
